import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./NavBar.scss";
import { useEffect, useState } from "react";
import NavbarBs from "react-bootstrap/Navbar";
import { isMobile } from "react-device-detect";
import { Container, Offcanvas } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { CarouselMessage } from "@/components/ui";
import { getBlogSubItems, images, NAVBAR_MENU_ITEMS, URLS, } from "@/utils/constants";
import store from "@/app/providers/redux/store";
import { setLoader } from "@/utils/constants/redux/sets";
import { NavContent } from "./NavContent/NavContent";
import { Logo } from "./Logo/Logo";
export const Navbar = () => {
    const { pathname } = useLocation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const toggleShow = () => setShow((s) => !s);
    const { blog } = store.getState().main.flags;
    useEffect(() => {
        setLoader(true);
    }, []);
    useEffect(() => {
        if (blog) {
            const { blogFlormorado } = JSON.parse(blog);
            NAVBAR_MENU_ITEMS[5].subItems = getBlogSubItems(blogFlormorado);
            setLoader(false);
        }
    }, [blog]);
    return (_jsxs("div", { className: "flormorado-navbar", children: [_jsx(CarouselMessage, {}), pathname !== URLS.checkout && (_jsx("div", { className: "container", children: _jsx(NavbarBs, { expand: "lg", children: _jsxs(Container, { fluid: true, children: [_jsx(NavbarBs.Brand, { href: "/", style: { marginRight: "0" }, children: _jsx(Logo, { src: images.Logo, width: 62 }) }), isMobile && (_jsx("a", { href: "/", children: _jsx(Logo, { src: images.LogoSoloNombreFondoBeige, width: 116 }) })), _jsx(NavbarBs.Toggle, { "aria-controls": `fmc-principal-navbar`, onClick: toggleShow }), _jsxs(NavbarBs.Offcanvas, { id: `fmc-principal-navbar`, "aria-labelledby": `fmc-principal-navbar-label`, placement: "end", show: show, className: "fmc-offcanvas", onHide: handleClose, children: [_jsx(Offcanvas.Header, { closeButton: true, children: _jsx(Offcanvas.Title, { id: `fmc-principal-navbar-label`, children: _jsx("h1", { className: "fmc-offcanvas-title", children: "FLORMORADO" }) }) }), _jsx(Offcanvas.Body, { children: _jsx(NavContent, { handleClose: handleClose }) })] })] }) }) }))] }));
};
